/*=========================================================================================
  File Name: rolesActions.js
  Description: Vuex Store - roles actions
==========================================================================================*/

import axios from 'axios';
import state from '../state';

export default {
    getDashboard({commit}, payload) {
        return new Promise((resolve, reject) => {
            let year_month = '';
            if (payload !== null) {
                year_month = '/' + payload.closed_customers_interval + '/' + payload.status_changes_interval + '/' + payload.last_three_months_interval + '/' + payload.year + '/' + payload.month;
            }

            axios({url: state.API_URL + '/auth/dashboard' + year_month, method: 'GET'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadMonthProductivity({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/month-productivity', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadClosedCustomers({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/closed-customers', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadStatusChanges({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/status-changes', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadLastThreeMonths({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/last-three-months', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadManagerRefusals({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/manager-refusals', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadManagerClientDelayedPayments({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/manager-client-delayed-payments', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadManagers({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/managers', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadRatings({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/ratings', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    reloadSpendBudgets({commit}, payload) {
        return new Promise((resolve, reject) => {
            axios({url: state.API_URL + '/auth/dashboard/spend', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    setRatings({commit}, payload) {
        return new Promise((resolve) => {
            axios({url: state.API_URL + '/auth/dashboard/set-ratings', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    useBlock({commit}, payload) {
        return new Promise((resolve) => {
            axios({url: state.API_URL + '/auth/dashboard/use-block', data: payload, method: 'POST'})
                .then(({data}) => {
                    resolve(data);
                });
        })
    },

    checkSchedule({commit}, payload) {
        return new Promise((resolve) => {
            axios({url: state.API_URL + '/auth/dashboard/check-schedule', data: payload, method: 'POST'});
        })
    },
};
